import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

import Breadcrumbs from "components/Common/Breadcrumb"
import AppUsers from "components/UserManagement/AppUsers/AppUsers"

import { Container, Row, Col } from "reactstrap"

import QuickGuide from "components/QuickGuides/QuickGuide"

const AppUserManagement = props => {
  const [quickGuide, setQuickGuide] = useState(false)

  const [usedIn] = useState({
    AppUserManagement,
  })

  useEffect(() => {
    document.title = props.t("Mobile app users") + " | Suvanto Care"
  }, [])

  return (
    <>
      <div className="page-content">
        <Container fluid className={quickGuide ? "quick-guide-open" : ""}>
          <Row className="align-items-baseline">
            <Col xs="6" className="d-flex align-items-baseline">
              <Breadcrumbs title={props.t("Mobile app users")} />
            </Col>
            <Col
              xs="6"
              className="d-flex align-items-baseline justify-content-end"
            >
              <QuickGuide
                source="appUsers"
                title="Mobile app users"
                isOpen={quickGuide}
                setIsOpen={setQuickGuide}
              />
            </Col>
          </Row>
          <AppUsers usedIn={usedIn} />
        </Container>
      </div>
    </>
  )
}

AppUserManagement.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(AppUserManagement)
